import { HttpClient } from "@angular/common/http";
import { TranslateLoader, type TranslationObject } from "@ngx-translate/core";
import { environment } from "environments/environment";
import { type Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n", "json");
}

class TranslateHttpLoader implements TranslateLoader {
  private http: HttpClient;
  prefix: string;
  suffix: string;

  constructor(http: HttpClient, prefix?: string, suffix?: string) {
    this.http = http;
    this.prefix = prefix;
    this.suffix = suffix;
  }

  getTranslation(lang: string): Observable<TranslationObject> {
    const excludeEnv = ["local", "develop"];
    const version = !excludeEnv.includes(environment.envName)
      ? `/${environment.version}`
      : "";
    const url = `${environment.AUTH_URL}${version}/${this.prefix}/${lang}.${this.suffix}`;
    return this.http.get<TranslationObject>(url).pipe(
      catchError((err) => {
        console.log(err);
        return of({} as TranslationObject);
      }),
    );
  }
}
